import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=101b57b8&scoped=true"
import script from "./InfoTable.vue?vue&type=script&lang=js"
export * from "./InfoTable.vue?vue&type=script&lang=js"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=101b57b8&prod&scoped=true&lang=scss"
import style1 from "./InfoTable.vue?vue&type=style&index=1&id=101b57b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101b57b8",
  null
  
)

export default component.exports